/**
 * Eyebrow with orange bar marker (inspired by "— LA REVOLUCIÓN AGÉNTICA" style).
 * Use above section titles to anchor visual hierarchy.
 */
export default function Eyebrow({ children, className = "" }) {
  return (
    <p className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.2em] text-foreground/90 ${className}`}>
      <span className="inline-block w-8 h-[3px] rounded-full bg-dc-amber dark:bg-dc-amber" />
      <span>{children}</span>
    </p>
  );
}
